import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import AccountsMenu from './AccountsMenu';
import { NavLink, Link } from 'react-router-dom';
import YearsDropDown from '../Shared/YearsDropDown';
import VoucherTypeDropDown from '../Shared/VoucherTypesDropDown';
import Pagination from "../General/Pagination";
import moment from "moment";
import { toast, ToastContainer } from 'react-toastify';

function ManageVouchers(props) {

    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [DefaultFYear, setDefaultFYear] = useState(localStorage.getItem("DefaultFYear"));
    const [VoucherType, setVoucherType] = useState(0);
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [voucherNo, setVoucherNo] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [appliedVoucherNo, setAppliedVoucherNo] = useState("");
    const [appliedStartDate, setAppliedStartDate] = useState("");
    const [appliedEndDate, setAppliedEndDate] = useState("");
    const [appliedVoucherType, setAppliedVoucherType] = useState(0);

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [grandTotalDebit, setGrandTotalDebit] = useState(0);
    const [grandTotalCredit, setGrandTotalCredit] = useState(0);
    const [isGrandBalanced, setIsGrandBalanced] = useState(true);

    const [loadingDelete, setLoadingDelete] = useState(false);
    const [IsDeleted, setIsDeleted] = useState(false);
    const [searchTrigger, setSearchTrigger] = useState(0);

    const fmtAmt = (v) =>
        Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

    document.title = 'Manage Vouchers';

    const runSearch = () => {
        setAppliedVoucherNo(voucherNo.trim());
        setAppliedStartDate(startDate);
        setAppliedEndDate(endDate);
        setAppliedVoucherType(VoucherType);
        setPageNo(1);
        setSearchTrigger((prev) => prev + 1);
    };

    const printUrl = `/Accounts/PrintManageVouchers?DefaultYear=${encodeURIComponent(
        DefaultFYear || ""
    )}&VoucherTypeID=${appliedVoucherType}&VoucherNo=${encodeURIComponent(
        appliedVoucherNo
    )}&StartDate=${encodeURIComponent(appliedStartDate)}&EndDate=${encodeURIComponent(
        appliedEndDate
    )}`;

    useEffect(() => {
        if (!DefaultFYear) {
            setLedger([]);
            setTotalRecords(0);
            setGrandTotalDebit(0);
            setGrandTotalCredit(0);
            setIsGrandBalanced(true);
            setLoading(false);
            return;
        }

        setIsDeleted(false);
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            FYear: parseInt(DefaultFYear, 10) || 0,
            VoucherTypeID: appliedVoucherType,
            VoucherNo: appliedVoucherNo,
            StartDate: appliedStartDate ? appliedStartDate : null,
            EndDate: appliedEndDate ? appliedEndDate : null,
        };

        axios({
            method: 'post',
            url: config.base_url + 'Voucher/GetVouchersByYear',
            headers: { 'Content-Type': 'application/json' },
            data: data
        })
            .then(function (response) {
                if (response.data.status_code === 1) {
                    setLedger(response.data.ListofRecords || []);
                    setTotalRecords(response.data.totalRecords || 0);
                    setGrandTotalDebit(response.data.GrandTotalDebit ?? 0);
                    setGrandTotalCredit(response.data.GrandTotalCredit ?? 0);
                    setIsGrandBalanced(response.data.IsGrandBalanced !== false);
                } else {
                    setLedger([]);
                    setTotalRecords(0);
                    setGrandTotalDebit(0);
                    setGrandTotalCredit(0);
                    setIsGrandBalanced(true);
                }
                setLoading(false);
            })
            .catch(function () {
                setLoading(false);
                setLedger([]);
                setTotalRecords(0);
                setGrandTotalDebit(0);
                setGrandTotalCredit(0);
                setIsGrandBalanced(true);
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });

    }, [pageNo, pageSize, DefaultFYear, IsDeleted, searchTrigger, appliedVoucherNo, appliedStartDate, appliedEndDate, appliedVoucherType, AccessKey, UserID, MemberType]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => {
                const isBalanced = item.IsBalanced !== false;
                return (
                    <tr key={index} className={!isBalanced ? "table-warning" : ""}>
                        <td>{item.ID}</td>
                        <td>{item.Voucher_code}</td>
                        <td>{item.Voucher_number}</td>
                        <td>{moment(item.Voucher_date).format('DD/MM/YYYY')}</td>
                        <td className="text-center">{item.FYear}</td>
                        <td className="text-end">{fmtAmt(item.TotalDebit)}</td>
                        <td className="text-end">{fmtAmt(item.TotalCredit)}</td>
                        <td>{item.Remarks}</td>
                        <td>
                            {item.Created_Date
                                ? moment(item.Created_Date).format("DD/MM/YYYY")
                                : ""}
                        </td>
                        <td>
                            {!isBalanced && (
                                <span className="badge bg-warning text-dark me-1" title="Debit and credit totals do not match">
                                    Unbalanced
                                </span>
                            )}
                            <ul className="inline-action d-inline-flex mb-0">
                                <li>
                                    <NavLink to={`/Accounts/EditVoucher/${item.ID}`} className="green">
                                        <i className="ri-edit-line"></i>
                                    </NavLink>
                                </li>
                                <li>
                                    <button type="button" onClick={() => DeleteVoucher(item.ID)} className="red">
                                        <i className="ri-delete-bin-line"></i>
                                    </button>
                                </li>
                            </ul>
                        </td>
                    </tr>
                );
            });
        }

        return (
            <tr>
                <td colSpan="10">
                    <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                        No Data Found
                    </h4>
                </td>
            </tr>
        );
    };

    const DeleteVoucher = (ID) => {
        const result = window.confirm('Are you sure you want to proceed?');

        if (result) {
            setLoadingDelete(true);
            axios({
                method: 'post',
                url: config.base_url + 'Voucher/DeleteVoucher',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    AccessKey: AccessKey,
                    UserID: UserID,
                    MemberType: MemberType,
                    ID: ID
                }
            })
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingDelete(false);
                        setIsDeleted(true);
                    } else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingDelete(false);
                    }
                })
                .catch(function () {
                    setLoadingDelete(false);
                });
        }
    };

    return (
        <>
            <ToastContainer />
            <AccountsMenu />

            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Manage Vouchers</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Manage Vouchers</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <NavLink to="/Accounts/AddVoucher" className="button button-white button-icon">
                                        Add Voucher
                                        <i className="ri-add-line"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body p-md-4">
                                <div className="row gy-3">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Select Year:</label>
                                            <select
                                                className="form-select"
                                                required
                                                name="ddlYears"
                                                value={DefaultFYear || ""}
                                                onChange={(e) => {
                                                    setDefaultFYear(e.target.value);
                                                    setPageNo(1);
                                                    setSearchTrigger((prev) => prev + 1);
                                                }}
                                            >
                                                <option value="">Please Select</option>
                                                <YearsDropDown selected={DefaultFYear} />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Select Type:</label>
                                            <select
                                                className="form-select"
                                                required
                                                name="ddlVoucherType"
                                                value={VoucherType || 0}
                                                onChange={(e) => setVoucherType(parseInt(e.target.value, 10) || 0)}
                                            >
                                                <option value="0">All Types</option>
                                                <VoucherTypeDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Voucher No:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={voucherNo}
                                                onChange={(e) => setVoucherNo(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        runSearch();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>From Date:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>To Date:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex gap-2 mt-4">
                                            <input
                                                type="button"
                                                value="Search"
                                                className="button button-primary flex-grow-1"
                                                onClick={runSearch}
                                            />
                                            <Link
                                                target="_blank"
                                                to={printUrl}
                                                className="button button-primary flex-grow-1 text-center"
                                            >
                                                Print
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-body table_card p-md-4">
                                {!loading && totalRecords > 0 && !isGrandBalanced && (
                                    <div className="alert alert-warning py-2 mb-3" role="alert">
                                        Grand debit and credit do not match for the filtered vouchers.
                                        Difference: {fmtAmt(Math.abs(grandTotalDebit - grandTotalCredit))}
                                        {" "}({grandTotalDebit > grandTotalCredit ? "debit higher" : "credit higher"})
                                    </div>
                                )}
                                <table className="table table-theme table-hover">
                                    <thead>
                                        <tr>
                                            <th colSpan={5}>
                                                {totalRecords} voucher{totalRecords === 1 ? "" : "s"} found
                                            </th>
                                            <th colSpan={5} className="text-end text-muted fw-normal">
                                                Grand total (all matching vouchers)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>ID</th>
                                            <th>Code</th>
                                            <th>Voucher No</th>
                                            <th>Dated</th>
                                            <th className="text-center">Year</th>
                                            <th className="text-end">Total Debit</th>
                                            <th className="text-end">Total Credit</th>
                                            <th>Details</th>
                                            <th>Created Date</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="10">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : (
                                            renderLedger()
                                        )}
                                    </tbody>
                                    {!loading && totalRecords > 0 && (
                                        <tfoot>
                                            <tr className={!isGrandBalanced ? "table-warning" : ""}>
                                                <th colSpan={5} className="text-end">
                                                    Grand total
                                                </th>
                                                <th className="text-end">{fmtAmt(grandTotalDebit)}</th>
                                                <th className="text-end">{fmtAmt(grandTotalCredit)}</th>
                                                <th colSpan={3}>
                                                    {!isGrandBalanced && (
                                                        <span className="badge bg-warning text-dark">
                                                            Difference {fmtAmt(Math.abs(grandTotalDebit - grandTotalCredit))}
                                                        </span>
                                                    )}
                                                </th>
                                            </tr>
                                        </tfoot>
                                    )}
                                </table>

                                {totalRecords > pageSize && (
                                    <div className="pagination-wrap">
                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                    <div className="form-group">
                                                        <select
                                                            className="form-select"
                                                            style={{ width: "100px" }}
                                                            value={pageSize}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value, 10));
                                                            }}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                            <option value="500">500</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageVouchers;
